import { render, staticRenderFns } from "./CreateNewGalleryModal.vue?vue&type=template&id=618f717d&scoped=true&"
import script from "./CreateNewGalleryModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewGalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f717d",
  null
  
)

export default component.exports